var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1NewHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair-3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M477.2,181.2c20.6,9.9,7.8,54.5,4.1,66.4c17.7-13.7,41.8-38.3,46.6-59.8c4.9-21.6,21.5-63.5-23.3-109.3 c-32.7-33.3-87.9-61-123.3-62c-39.4-1.2-107.7,16.3-138.7,34c-46.7,26.7-70,80.7-69.3,104c0.6,19.9,4.2,46.7,15.3,62 c7.4,10.1,22.1,22.1,36,22.7c-13.2-9.2-18-51.3,10.7-52.7c-12.8-16.6,44.2-18,53.5-18.8c39.7-3.4,81.6-7.8,121,1.3 C432.6,174.3,460.2,171,477.2,181.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M501.1,187.7l-0.6-17.3c-1.1-15.8-0.4-18.6-7.3-21c-1.3-0.4-2.6-0.9-3.9-1.3 c-19.4-6.4-39.7-11.2-60.3-14.4c-3.7-0.6-7.4-1.1-11-1.6c-30.2-5.2-61.2-7.8-92.6-7.1c-3.9,0.1-7.9,0.2-11.8,0.4 c-34.2,1.8-68.2,7-99.3,18.1c-1.5,0.5-2.9,1-4.3,1.6c-3.2,1.2-11.3-0.2-5.6,48.3l0.1,3.5c1.3,9.7,6.2,11.5,11.1,9.9 c0.4-0.1,0.8-0.2,1.2-0.4c2.1-0.6,4.2-1.2,6.3-1.8c15.4-4.1,31.1-7.1,47.1-9.2c8-1.1,16-1.9,24.2-2.6c38.1-2.6,75.9-2.2,113.2,1.8 c7.4,0.8,14.8,1.7,22.2,2.8c14.4,2.2,28.7,5.2,42.6,9C486.5,210.4,502.6,217.9,501.1,187.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M325.3,125c31.4-0.6,62.4,2,92.6,7.1c3.7,0.5,7.4,1,11,1.6c20.6,3.2,40.9,7.9,60.3,14.4 c0.2-2.6,0.3-5.3,0.2-7.9c0-3.4-0.3-6.7-0.7-10c-2.9-24.4-15-49.9-36.5-67.5c-3.1-2.5-6.3-4.9-9.8-7c-18.3-12-40.6-16.9-63.6-18.4 c-3.8-0.2-7.7-0.4-11.6-0.5c-40.8-0.1-86,3.4-116.8,27.6c-3.3,2.4-6.3,4.9-9.1,7.5c-20.4,19.4-28.4,45.6-27.4,71.6 c31.2-11.1,65.1-16.2,99.3-18.1C317.4,125.2,321.4,125,325.3,125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M484.4,143.4c-2.6-1.1-5.3-2.1-8-3.2c-18-6.8-36.7-12.3-56-16.6c-3.8-0.9-7.7-1.7-11.6-2.4 c-42.7-8.4-86.6-9.9-129.9-5.7c-3.9,0.4-7.8,0.9-11.7,1.4c-7.7,1.1-15.3,2.5-22.7,4.4c4.1-31.5,24.7-61.2,56.3-78.9 c0.2-0.1,0.3-0.2,0.5-0.3c-18.8,4-36.3,10.8-50.8,22.1c-3.3,2.4-6.3,4.9-9.1,7.5C221,91.1,213,117.3,214,143.3 c31.2-11.1,65.1-16.2,99.3-18.1c3.9-0.2,7.9-0.3,11.8-0.4c31.4-0.6,62.4,2,92.6,7.1c3.7,0.5,7.4,1,11,1.6 c20.6,3.2,40.9,7.9,60.3,14.4c0.1-0.8,0.1-1.7,0.1-2.5C487.7,144.8,486.1,144.1,484.4,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M234.1,182.3c7.3-14.5,15.8-29.7,9.2-47.5c-9.9,2.3-19.7,5.2-29.1,8.5c-1.5,0.5-2.9,1-4.3,1.6 c-3.2,1.2-11.3-0.2-5.6,48.3l0.1,3.5c1.3,9.7,6.2,11.5,11.1,9.9c0.4-0.1,0.8-0.2,1.2-0.4c2.1-0.6,4.2-1.2,6.3-1.8 c5.2-1.4,10.5-2.6,15.8-3.8C235.7,194.7,231.8,187.9,234.1,182.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M357.2,26c-12.4-6.6-27.1,1.4-29.7,12.3c12-1.1,24.2-1.5,36-1.6C362.9,32.7,361.7,28.3,357.2,26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M312.6,128.7c3.9-0.2,7.9-0.3,11.8-0.4c31.4-0.6,62.4,2,92.6,7.1c3.7,0.5,7.4,1,11,1.6 c24.5,3.8,48.4,9.7,71,18.1c-0.8-3.2-2.4-4.5-5.9-5.7c-1.3-0.4-2.6-0.9-3.9-1.3c-7.1-2.4-14.4-4.5-21.8-6.4l-0.3-7.3 c-3.6-31.9-16.8-59-42.7-82c25.7,23.4,36.4,50.9,39.8,82.2l0.3,6.4c-11.6-2.9-23.5-5.3-35.5-7.2l-0.7-6.8 c-4.2-30.5-14.9-55.7-32.6-81.7c17.4,26.3,25.7,51.9,29.7,81.9l0.6,6.1c-2.8-0.4-5.5-0.8-8.3-1.2c-10.5-1.8-21.1-3.3-31.8-4.4 l-0.3-6.3c-1.5-28-3-52.3-13.6-78.6c10.3,26.4,9.4,50.7,10.7,78.6l0.3,5.9c-11-1.1-22.1-1.9-33.2-2.2l0.1-6 c0.1-26.9-2.2-49.7-6.5-75.7c3.8,26.1,3.8,48.9,3.6,75.7l-0.1,5.9c-7.3-0.2-14.6-0.2-21.9-0.1c-3.9,0.1-7.9,0.2-11.8,0.4 c-1.5,0.1-3,0.2-4.6,0.3l-0.4-5.4c-1.7-26.6-1.7-50.1,10.3-74.7c-12.3,24.3-14.8,48-13.2,74.8c0.1,1.9,0.3,3.7,0.4,5.5 c-12.1,0.8-24.1,2.1-36,3.9c-0.3-1.7-0.7-3.5-0.8-5.2c-2.5-24.9,1.3-46.9,12.7-69.7c-11.8,22.6-18,44.4-15.6,69.9 c0.2,1.8,0.5,3.6,0.9,5.4c-8.1,1.3-16.1,2.9-23.9,4.7c-0.2-1.5-0.5-3.1-0.5-4.6c-1.6-22.9,3-42.7,11.6-64.1 c-9,21.3-15.9,40.8-14.5,64.3c0.1,1.8,0.4,3.5,0.6,5.2c-8.9,2.2-17.7,4.8-26.3,7.8c-1.5,0.5-2.9,1-4.3,1.6 c-1.5,0.6-4,0.5-5.7,5.2c3.4-1.4,6.8-2.6,10.2-3.8C245.2,135.5,278.8,130.5,312.6,128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M407.8,190.7c-37.2-4-75-4.4-113.2-1.8c-8.1,0.6-16.2,1.5-24.2,2.6c-16,2.1-31.7,5.1-47.1,9.2 c-2.5,0.7-5,1.4-7.5,2.1c-2.7,0.8-5.3,1.7-8,2.7c2.1,1.9,4.8,2.1,7.5,1.3c0.4-0.1,0.8-0.2,1.2-0.4c2.1-0.6,4.2-1.2,6.3-1.8 c15.4-4.1,31.1-7.1,47.1-9.2c8-1.1,16-1.9,24.2-2.6c38.1-2.6,75.9-2.2,113.2,1.8c7.4,0.8,14.8,1.7,22.2,2.8 c14.4,2.2,28.7,5.2,42.6,9c8,2.2,16.6,5.5,22.3,2.8c-20.6-7.1-42.3-12.3-64.4-15.7C422.6,192.4,415.2,191.4,407.8,190.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M233.4,195.3c-7.3-16.7-5.8-31.9-4.6-48.5c-0.6,16.7,1.5,31.6,8.6,47.2l2,4.2l-3.8,1.4L233.4,195.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M261.1,190.1c-5.9-17-6.8-32.3-4.1-49.1c-2.1,17,2.4,31.8,8.2,48.1c0.5,1.5,1.2,2.9,1.8,4.3l-3.9,1.2 C262.3,193.1,261.6,191.6,261.1,190.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M293,186.4c-4.1-17.3-5.6-32.5-4.7-49.6c-0.3,17.2,4.6,31.8,8.8,48.9l1.2,4.6l-4.1,0.7L293,186.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M327.8,184.6c-3.4-17.8-1.2-33.1,1.7-50.1c-2.3,17.2-1,32.4,2.5,49.6l1,4.6l-4.1,0.7L327.8,184.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M364,184.5c3.3-17.5,6-32.7,4-50.3c2.6,17.4,3.4,32.9,0.2,50.8l-0.9,4.8l-4.2-0.6L364,184.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M404,187.8c4.6-17.1,6.8-32.4,3.1-49.7c4.3,17,5.6,32.7,1.1,50.5l-1.5,4.7l-4.1-1L404,187.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M443.1,193.7c3.1-16.3,4.7-30.8,1.2-47.1c4,16.1,6,30.8,3,47.7l-0.9,4.5l-4.1-0.7L443.1,193.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M471.4,199.3c4.1-15.8,7.2-29.7,5.9-45.8c2,16,2.3,30.3-1.7,46.6l-1.2,4.3l-4.1-0.9L471.4,199.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M303.9,49.8c-0.4,1.6-1.5,2.8-2.5,2.6s-1.5-1.6-1.1-3.2c0.4-1.6,1.5-2.8,2.5-2.6 C303.8,46.7,304.3,48.2,303.9,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M293.7,74.1c-0.3,1.3-1.3,2.3-2.1,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.3-2.3,2.1-2.2 C293.7,71.5,294.1,72.7,293.7,74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M255.2,103c-0.3,1.3-1.3,2.3-2.1,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.3-2.3,2.1-2.2 C255.1,100.5,255.5,101.7,255.2,103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M248.5,181.3c0,1.4-0.6,2.5-1.4,2.5c-0.8,0-1.5-1.1-1.6-2.4c0-1.4,0.6-2.5,1.4-2.5 S248.4,179.9,248.5,181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M278.8,140.7c0,1.6-0.7,3-1.7,3s-1.8-1.3-1.9-2.9c0-1.6,0.7-2.9,1.7-3 C277.9,137.8,278.7,139.1,278.8,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M275.6,179.1c0.4,1.6-0.1,3-1.1,3.2s-2.1-1-2.5-2.6s0.1-3,1.1-3.2S275.2,177.5,275.6,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M308.4,161.1c0.3,1.6-0.3,3-1.3,3.1s-2-1.1-2.3-2.7c-0.3-1.6,0.3-3,1.3-3.1S308.2,159.5,308.4,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M320,135.3c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.4-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9S320.1,133.7,320,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M348.4,139.1c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.4-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C347.6,136.2,348.4,137.5,348.4,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M343.4,176.4c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.4-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C342.7,173.5,343.4,174.8,343.4,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M386.4,151.3c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.4-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C385.7,148.3,386.4,149.6,386.4,151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M390.6,179.6c-0.3,1.6-1.3,2.8-2.3,2.7s-1.6-1.5-1.3-3.1c0.3-1.6,1.3-2.8,2.3-2.7 C390.3,176.6,390.9,178,390.6,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M431.9,174.1c-0.3,1.6-1.3,2.8-2.3,2.7s-1.6-1.5-1.3-3.1c0.3-1.6,1.3-2.8,2.3-2.7 S432.2,172.5,431.9,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M460.4,157.3c0,1.6-0.8,2.9-1.8,2.9s-1.8-1.3-1.8-3s0.8-2.9,1.8-2.9C459.6,154.4,460.4,155.7,460.4,157.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M462.5,189.6c-0.2,1.6-1.1,2.9-2.1,2.8c-1-0.1-1.7-1.4-1.5-3.1c0.2-1.6,1.1-2.9,2.1-2.8 C462,186.6,462.7,188,462.5,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M489.5,160.9c0,2-1.1,3.6-2.3,3.6c-1.2,0-2.2-1.7-2.2-3.7s1.1-3.6,2.3-3.6 C488.6,157.2,489.6,158.9,489.5,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M285.4,102.8c-0.3,1.4-1.2,2.5-2,2.4c-0.9-0.1-1.4-1.3-1.1-2.8c0.3-1.4,1.2-2.5,2-2.4 C285.1,100.2,285.6,101.4,285.4,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M265.7,65.3c-0.8,1.7-2.4,2.8-3.4,2.4c-1-0.3-1.2-2-0.3-3.7c0.8-1.7,2.4-2.8,3.4-2.4 C266.4,62,266.6,63.6,265.7,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M235.5,101.8c-0.5,1.8-1.9,3-2.9,2.8c-1.1-0.2-1.5-1.8-1-3.6c0.5-1.8,1.9-3,2.9-2.8 C235.6,98.4,236.1,100,235.5,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M227.2,124.5c-0.1,1.8-1.1,3.3-2.2,3.2c-1.1,0-1.9-1.5-1.9-3.4c0.1-1.8,1.1-3.3,2.2-3.2 C226.5,121.1,227.3,122.6,227.2,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M216.5,172.7c-0.1,1.8-1.1,3.3-2.2,3.2c-1.1,0-1.9-1.5-1.9-3.4c0.1-1.8,1.1-3.3,2.2-3.2 C215.8,169.4,216.6,170.9,216.5,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M242.3,155.7c-0.1,1.6-1,2.9-2,2.9s-1.8-1.4-1.7-3s1-2.9,2-2.9C241.7,152.7,242.4,154.1,242.3,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M217,196.3c0.3,1.4-0.1,2.7-0.9,2.8c-0.8,0.1-1.8-0.9-2.1-2.3c-0.3-1.4,0.1-2.7,0.9-2.8 C215.7,193.8,216.6,194.8,217,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M326.5,65c0,1.4-0.7,2.6-1.6,2.6s-1.6-1.2-1.6-2.6s0.7-2.6,1.6-2.6S326.5,63.6,326.5,65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M323.9,103.3c-0.1,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.6-1.2-1.5-2.6c0-1.4,0.8-2.6,1.7-2.5 C323.2,100.7,323.9,101.8,323.9,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M361.3,63.6c0,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.6-1.2-1.5-2.6c0-1.4,0.8-2.6,1.7-2.5 C360.7,61,361.4,62.2,361.3,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M364.3,85.6c-0.1,1.4-0.8,2.6-1.7,2.5c-0.9,0-1.6-1.2-1.5-2.6c0-1.4,0.8-2.6,1.7-2.5 C363.7,83,364.4,84.2,364.3,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M392.6,61.8c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.8-1-2-2.4s0.3-2.6,1.2-2.7 C391.5,59.3,392.4,60.4,392.6,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M400.9,105.6c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.8-1-2-2.4s0.3-2.6,1.2-2.7 C399.8,103.1,400.7,104.2,400.9,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M429.8,80c0.5,1.4,0.1,2.7-0.7,2.8c-0.9,0.2-1.9-0.8-2.4-2.2c-0.5-1.4-0.1-2.7,0.7-2.8 C428.3,77.6,429.4,78.6,429.8,80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M446.4,113.9c0.4,1.4,0,2.7-0.8,2.8c-0.9,0.2-1.9-0.8-2.3-2.2c-0.4-1.4,0-2.7,0.8-2.8 S445.9,112.6,446.4,113.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M468.3,92.8c0.4,1.4,0,2.7-0.8,2.8c-0.9,0.2-1.9-0.8-2.3-2.2c-0.4-1.4,0-2.7,0.8-2.8 C466.9,90.4,467.9,91.4,468.3,92.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1NewHair3);
export default __webpack_public_path__ + "static/media/m-hat1_new-hair3.69496c79dc3fc27a52c5f0ecbb88b40b.svg";
export { ForwardRef as ReactComponent };